@let localQualification = qualification();
@let localInfoCalification = infoCalification();

<article class="valoration-card" [class.valoration-card--compact]="variant() === 'compact'">
  <div class="valoration-card__header">
    <div>
      <span class="valoration-card__eyebrow">
        <i class="inm-icon-star" aria-hidden="true"></i>
        {{ 'geomarker.title_card_rating' | translate }}
      </span>
    </div>
    @if (hasQualification()) {
      <span class="valoration-card__status">{{ 'rating_modal.already_rated' | translate }}</span>
    }
  </div>

  <div class="valoration-card__summary">
    <strong>{{ localQualification }}</strong>
    <div>
      <app-rating [showRatingNumber]="false" [qualification]="+localQualification" [disabled]="true" size="20px" />
      <span>{{ localInfoCalification?.total_ratings || 0 }} {{ 'valoraciones' | translate }}</span>
    </div>
  </div>

  @if (variant() !== 'compact') {
    <div class="valoration-card__breakdown">
      @for (q of qualificationArray(); track q.qualification) {
        <div class="rating-breakdown-row">
          <span>{{ q.qualification }}</span>
          <div><span [style.width.%]="q.percentage"></span></div>
          <small>{{ q.percentage }}%</small>
        </div>
      }
    </div>
  }

  <button
    type="button"
    class="valoration-card__action"
    [disabled]="busy()"
    (click)="editCalification()"
  >
    <i class="inm-icon-star" aria-hidden="true"></i>
    {{ (hasQualification() ? 'rating_modal.edit_button' : 'calificar') | translate }}
  </button>
</article>
